import { useAskInChatStore } from "#features/conversations/stores/useAskInChatStore.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Button, Div, Flex, Text } from "@hopper-ui/components";
import { IconReply, IconX } from "@intentui/icons";

export const ConversationInputTargetedReply = () => {
    const { tShared } = useSharedTranslation();
    const targetedReply = useAskInChatStore(state => state.askInChatOptions?.targetedReply);
    const reset = useAskInChatStore(state => state.reset);

    if (!targetedReply) {
        return null;
    }

    return (
        <Div
            paddingY="inset-sm"
            paddingX="inset-md"
        >
            <Flex
                padding="inset-sm"
                gap="inline-sm"
                backgroundColor="neutral-weakest"
                borderRadius="rounded-md"
                color="neutral-weak"
            >
                <IconReply />
                <Text
                    size="xs"
                    color="neutral-weak"
                    flexGrow={1}
                    className="wai-line-clamp wai-line-clamp-3"
                >
                    {targetedReply}
                </Text>
                <Button
                    variant="ghost-secondary"
                    flexShrink={0}
                    size="xs"
                    aria-label={tShared("dismiss")}
                    borderRadius="circle"
                    className="wai-composer-ghost"
                    onPress={reset}
                >
                    <IconX />
                </Button>
            </Flex>
        </Div>
    );
};
